module.exports = __webpack_public_path__ + "static/media/erecht24-privacy.fc8819bc.png";